<template>
  <div>
    <custom-dialog
      :openDialog="isOpen"
      :widthDialog="'1000px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('closed')"
    >
      <template #body>
        <h3 class="dialogTitle">Yêu cầu văn phòng phẩm</h3>
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-position="left"
          label-width="150px"
          inline-message
          class="form-account width__100 margin-top-10"
        >
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="Tên yêu cầu: " prop="title">
                <el-input
                  class="style-fullWidth input-border__bottom input-border__radius__0"
                  v-model="form.title"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24" v-if="!!id">
            <el-col :span="24">
              <el-form-item label="Đơn vị yêu cầu">
                <el-input
                  class="style-fullWidth input-border__bottom input-border__radius__0"
                  :readonly="true"
                  v-model="requestedDeptName"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="Tổng hạn mức:">
                <el-input
                  class="style-fullWidth input-border__bottom input-border__radius__0 number-input"
                  v-model="totalStr"
                  :readonly="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Ứng trước:">
                <el-input
                  class="style-fullWidth input-border__bottom input-border__radius__0 number-input"
                  v-model="approvedTotalStr"
                  :readonly="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Hạn mức còn lại:">
                <el-input
                  class="style-fullWidth input-border__bottom input-border__radius__0 number-input"
                  v-model="remainingTotalStr"
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="24">
              <div
                class="group__info margin-top-15 margin-bottom-10 padding-bottom-10"
              >
                <div class="title font-size__medium">
                  Danh mục văn phòng phẩm
                </div>
                <div class="ctn">
                  <template>
                    <el-table
                      :data="form.items"
                      stripe
                      size="medium"
                      style="width: 100%"
                      class="table detailRelatedDocs"
                      show-summary
                      :summary-method="getSummaries"
                    >
                      <el-table-column
                        label="Tên VPP"
                        width="300px"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <el-autocomplete
                            class="style-fullWidth input-border__radius__0"
                            v-model="scope.row.name"
                            :fetch-suggestions="searchCategoryName"
                            placeholder="Nhập tên để tìm kiếm"
                            :trigger-on-focus="false"
                            @select="
                              vppCategory =>
                                handleCategoryNameSelect(scope.row, vppCategory)
                            "
                            v-if="!scope.row.vppCategoryId"
                          >
                            <template slot-scope="{ item }">
                              <div class="value">{{ item.name }}</div>
                            </template>
                          </el-autocomplete>
                          <span v-else>
                            {{ scope.row.name }}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Đ/vị" width="70px">
                        <template slot-scope="scope">
                          {{ scope.row.donvi || "-" }}
                        </template>
                      </el-table-column>
                      <el-table-column label="Mô tả" width="150px">
                        <template slot-scope="scope">
                          {{ scope.row.description || "-" }}
                        </template>
                      </el-table-column>
                      <el-table-column label="Xuất xứ" width="100px">
                        <template slot-scope="scope">
                          {{ scope.row.xuatxu || "-" }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Đơn giá"
                        width="120px"
                        align="right"
                      >
                        <template slot-scope="scope">
                          {{ formatCurrency(scope.row.dongia) || "-" }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Số lượng"
                        width="100px"
                        align="right"
                      >
                        <template slot-scope="scope">
                          <el-input-number
                            :min="0"
                            :step="1"
                            :precision="0"
                            :controls="false"
                            class="style-fullWidth input-border__radius__0 number-input"
                            v-model="scope.row.count"
                            v-if="scope.row.vppCategoryId"
                            @change="value => countChanged(value, scope.row)"
                          >
                          </el-input-number>
                          <div v-else class="flex-row flex__right">
                            <span> - </span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="Thành tiền" align="right">
                        <template slot-scope="scope">
                          {{ formatCurrency(scope.row.total) || "-" }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </template>

      <template #footer>
        <div class="flex-row flex__left form-button__action margin-top-10">
          <el-button
            type="success"
            size="mini"
            class="addDocs btn-none__border  color__white bg__blue"
            @click="save"
          >
            <span class="flex-row flex__center">
              <i class="fas fa-save font-size__medium"></i>
              &nbsp;&nbsp;Lưu
            </span>
          </el-button>
          <el-button
            type="info"
            size="mini"
            class="addDocs btn-none__border  color__white bg__green"
            v-if="id && mode === 'approveMode' && status === 'waitForApproving'"
            @click="approve"
          >
            <span class="flex-row flex__center">
              <i class="fas fa-check font-size__medium"></i>
              &nbsp;&nbsp;Duyệt
            </span>
          </el-button>
          <el-button
            type="info"
            size="mini"
            class="addDocs btn-none__border  color__white bg__red"
            v-if="id"
            @click="delete_"
          >
            <span class="flex-row flex__center">
              <i class="fas fa-trash font-size__medium"></i>
              &nbsp;&nbsp;Xóa
            </span>
          </el-button>
          <el-button
            type="info"
            size="mini"
            class="btn__cancel btn-none__border"
            @click="cancel"
          >
            <span class="flex-row flex__center">
              <i class="far fa-times-circle font-size__medium"></i>
              &nbsp;&nbsp;Hủy
            </span>
          </el-button>
        </div>
      </template>
    </custom-dialog>
  </div>
</template>

<script>
  import CustomDialog from "../../common/custom-dialog";
  import vanphongphamService from "../../../services/vanphongphamService";
  import h from "../../../services/h";
  import utils from "../../../services/utils";

  export default {
    name: "vanphongpham-create-dialog",
    props: ["isOpen", "id", "mode"],
    components: {CustomDialog},
    data() {
      return {
        total: 0,
        approvedTotal: 0,
        remainingTotal: 0,
        totalStr: null,
        approvedTotalStr: null,
        remainingTotalStr: null,
        requestedDeptName: null,
        selectedItem: null,
        form: {
          title: null,
          items: []
        },
        rules: {
          title: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ]
        }
      };
    },

    computed: {
      status() {
        return this.selectedItem ? this.selectedItem.status : null;
      },
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      },
      deptId() {
        return this.userDeptRole.deptId;
      },
      deptName() {
        return this.userDeptRole.deptName;
      }
    },

    watch: {
      total(newValue) {
        this.totalStr = utils.formatCurrency(newValue);
      },

      approvedTotal(newValue) {
        this.approvedTotalStr = utils.formatCurrency(newValue);
        console.log(this.approvedTotalStr);
      },

      remainingTotal(newValue) {
        this.remainingTotalStr = utils.formatCurrency(newValue);
      },
    },

    created() {
      this.initPage();
      if (this.id) this.initFormForEdit();
    },

    methods: {
      calculateSummary() {
        let grandTotal = 0;
        h.each(
          this.form.items,
          item =>
            (grandTotal += item.vppCategoryId
              ? (item.count || 0) * (item.dongia || 0)
              : 0)
        );
        return grandTotal;
      },

      getSummaries() {
        return ["Tổng", null, null, null, null, null, utils.formatCurrency(this.calculateSummary())];
      },

      searchCategoryName(query, cb) {
        vanphongphamService
          .searchCategories(query)
          .then(response => cb(response.data));
      },

      handleCategoryNameSelect(row, vppCategory) {
        row.vppCategoryId = vppCategory.id;
        row.name = vppCategory.name;
        row.donvi = vppCategory.donvi;
        row.description = vppCategory.description;
        row.xuatxu = vppCategory.xuatxu;
        row.dongia = vppCategory.dongia;
        row.count = 1;
        row.total = row.dongia * row.count;
        this.form.items.push(this.initNewItem());
      },

      countChanged(value, row) {
        row.total = row.dongia * row.count;
      },

      initNewItem() {
        return {
          vppCategoryId: null,
          name: null,
          donvi: null,
          description: null,
          xuatxu: null,
          dongia: null,
          count: null,
          total: null
        };
      },

      initFormForEdit() {
        vanphongphamService.findById(this.id).then(response => {
          let item = (this.selectedItem = response.data);
          this.form.title = item.title;
          this.requestedDeptName = item.deptName;
          Promise.all(
            h.collect(item.items, item => {
              return vanphongphamService
                .findVppCategoryId(item.vppCategoryId)
                .then(response2 => {
                  let vppCategory = response2.data;
                  return {
                    vppCategoryId: vppCategory.id,
                    name: vppCategory.name,
                    donvi: vppCategory.donvi,
                    description: vppCategory.description,
                    xuatxu: vppCategory.xuatxu,
                    dongia: item.dongia,
                    count: item.count,
                    total: item.total
                  };
                });
            })
          ).then(items => {
            this.form.items = items || [];
            this.form.items.push(this.initNewItem());
          });
        });
      },

      initPage() {
        this.form.items = [this.initNewItem()];
        this.total = vanphongphamService.getLimitTotal(this.deptId);
        this.approvedTotal = vanphongphamService.getApprovedTotal(this.deptId);
        this.remainingTotal = this.total - this.approvedTotal;

        this.totalStr = utils.formatCurrency(this.total);
        this.approvedTotalStr = utils.formatCurrency(this.approvedTotal);
        this.remainingTotalStr = utils.formatCurrency(this.remainingTotal);
      },

      formatCurrency(value) {
        return value == null ? null : utils.formatCurrency(value);
      },

      convertToSubmitForm() {
        let items = h.findAll(this.form.items, item => item.vppCategoryId);
        return {
          title: this.form.title,
          deptName: this.deptName,
          deptId: this.deptId,
          items: h.collect(items, item => {
            return {
              vppCategoryId: item.vppCategoryId,
              count: item.count,
              total: item.total,
              dongia: item.dongia
            };
          }),
          total: this.calculateSummary()
        };
      },

      validate() {
        return new Promise(resolve => {
          this.$refs.form.validate(valid => {
            if (!valid) {
              this.notify(
                "Lỗi",
                "Có lỗi nhập liệu. Vui lòng kiểm tra lại",
                "error",
                2000
              );
              return;
            }
            if (!this.validateTotal()) return;
            resolve();
          });
        });
      },

      validateTotal() {
        let total = this.calculateSummary();
        if (total > this.remainingTotal) {
          this.notify(
            "Lỗi",
            `Tổng tiền [${total}] đã vượt quá hạn mức còn lại [${
              this.remainingTotal
            }]`,
            "error",
            2000
          );
          return false;
        }
        return true;
      },

      save_() {
        return new Promise(resolve => {
          this.validate().then(() => {
            let submitForm = this.convertToSubmitForm();
            return (!this.id
                ? vanphongphamService.insert(submitForm, this.userDeptRole)
                : vanphongphamService.update(this.id, submitForm)
            )
          })
            .then(() => resolve());
        })
      },

      save() {
        this.save_().then(() => {
          this.notify(
            "Thông báo",
            !this.id
              ? "Tạo mới yêu cầu thành công"
              : "Cập nhật yêu cầu thành công",
            "success",
            2000
          );
          this.$emit("success");
        });
      },

      approve() {
        this.save_()
          .then(() => vanphongphamService.approve(this.id))
          .then(() => {
            this.notify(
              "Thông báo",
              "Phê duyệt yêu cầu thành công",
              "success",
              2000
            );
            this.$emit("success");
          });
      },

      delete_() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.$confirm("Bạn có muốn hủy yêu cầu này?", "Thông báo", {
              confirmButtonText: "Xác nhận",
              cancelButtonText: "Bỏ qua",
              type: "warning"
            }).then(() => {
              return vanphongphamService.delete(this.id).then(() => {
                this.notify(
                  "Thông báo",
                  "Hủy yêu cầu thành công",
                  "success",
                  2000
                );
                this.$emit("success");
              });
            });
          }
        });
      },

      cancel() {
        this.$emit("closeDialog");
      }
    }
  };
</script>

<style>
  .number-input input.el-input__inner {
    text-align: right !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/vanphongpham/vanphongpham-create-dialog.vue